import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import APIS from "./utils/APIS"
import { isLoggedIn, setUser } from "./utils/auth"

import { ConfirmProvider } from "material-ui-confirm";

const checkLoggedRefresh = () => {
  APIS.getLoginStatus().then(result => {
    if (result?.message == "status" && result?.user) {
      let actUser = isLoggedIn()
      if (actUser === false) {
        //on doit donc logger le user et reload
        setUser(result?.user)
        document.location.reload()
      } else {
        if (actUser !== result?.user?.id) { //problème, on logout et reload
          setUser({})
          document.location.reload()
        }
      }
    } else if (result?.reseauIndisponible === true) {
      // 02/09/2026 : le serveur n'a pas repondu. On ne sait pas si la session
      // est encore valable, donc on ne touche a rien. Vider setUser({}) ici
      // deconnectait pour de bon un utilisateur dont la session etait intacte,
      // pour un simple creux de reseau ou un redemarrage du back.
      console.log("statut de session indisponible, on garde la session en place")
    } else {
      if (isLoggedIn()) {
        setUser({})
        document.location.reload()
      }
    }
  })
}
checkLoggedRefresh()


/* ⛔ R18-b — 23/09/2026. `createRoot` remplace l'ancien point de montage : React 18
   cesse de tourner en mode de compatibilite React 17. Consequence voulue : le
   REGROUPEMENT AUTOMATIQUE des mises a jour d'etat s'active partout (promesses,
   minuteurs, evenements hors React). C'est la seule vraie modification de
   comportement de toute la migration.
   Filet qui le garde : `src/parcours/__tests__/` (Palier 0 + D2), qui montent
   eux aussi avec `createRoot` (`src/parcours/monter-racine.js`).
   Retour arriere : le tag git `avant-r18b`. */
createRoot(document.getElementById('root')).render(
  (
    <BrowserRouter>
      <ConfirmProvider
        /* ⛔ COMPATIBILITE VOLONTAIRE ET TEMPORAIRE — 23/09/2026.
           material-ui-confirm 4.0.0 a CHANGE son contrat : la promesse RESOUT
           desormais toujours, avec { confirmed, reason }. Avant la 4, elle
           REJETAIT a l'annulation. Les cinq appels du depot sont tous ecrits
           pour l'ancien contrat :
             GroupMailing 660/822/865  .then(action destructrice).catch(rien)
             GroupForm 74              try/await -> "ok" | catch -> "cancel"
           Sans ce drapeau, « Annuler » supprimerait un template, un mailing,
           ou forcerait un envoi. Et dans GroupForm ligne 393, ou le bouton
           d'annulation s'appelle « Supprimer », la branche destructrice ne
           partirait plus jamais.
           ⚠️ C'est une compatibilite, pas une cible. Migrer les cinq appels
           vers `result.confirmed` est un LOT SEPARE, avec son propre test :
           ce code est destructif et n'est couvert par aucun parcours.
           Garde : `src/parcours/__tests__/D2-gardes-appels.test.js` test 4. */
        useLegacyReturn
      >
        <App />
      </ConfirmProvider>
    </BrowserRouter>
  )
);
